export default __webpack_public_path__ + "static/media/light-off.17cece82.svg";